module.exports = __webpack_public_path__ + "img/hsl.eb1da2fc.png";